import { listOption } from '@/api/base/basePortType'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
